// client/src/pages/Membership.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Layout from '../components/Layout';
import request from '../utils/request';

function Membership() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [submitting, setSubmitting] = useState(false);
  const [config, setConfig] = useState({ priceYuan: '399', quota_count: 6, expiry_months: 6 });

  useEffect(() => {
    request({ url: '/api/membership/config', method: 'GET' })
      .then((res) => setConfig(res.data || config))
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (searchParams.get('paid') === '1') {
      alert(`购买成功！${config.quota_count ?? 6}个牵线名额已到账`);
      navigate('/membership', { replace: true });
    }
  }, [searchParams, navigate, config.quota_count]);

  const handleBuy = async () => {
    setSubmitting(true);
    try {
      const res = await request({
        url: '/api/buy/create',
        method: 'POST'
      });
      if (res.data.payUrl) {
        window.location.href = res.data.payUrl;
      } else {
        alert(res.data.error || '创建订单失败');
      }
    } catch (err) {
      alert(err.response?.data?.error || '购买失败');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <div className="card" style={{ textAlign: 'center', padding: 24 }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>💰</div>
        <h2 style={{ marginBottom: 8 }}>会员开通</h2>
        <p style={{ fontSize: 36, fontWeight: 'bold', margin: '24px 0', color: '#ff6b6b' }}>
          ¥{config.priceYuan ?? '399'}
        </p>
        <p style={{ color: '#666', marginBottom: 24 }}>
          {config.quota_count ?? 6}个牵线名额 · 有效期{config.expiry_months ?? 6}个月
        </p>
        <ul style={{ textAlign: 'left', marginBottom: 24, lineHeight: 2, paddingLeft: 20 }}>
          <li>✓ 获得{config.quota_count ?? 6}个牵线名额</li>
          <li>✓ 有效期{config.expiry_months ?? 6}个月</li>
          <li>✓ 可主动发起牵线</li>
          <li>✓ 查看对方联系方式</li>
        </ul>
        <button
          className="btn btn-primary"
          onClick={handleBuy}
          disabled={submitting}
          style={{ width: '100%', marginBottom: 12 }}
        >
          {submitting ? '创建订单中...' : '立即购买'}
        </button>
        <button
          className="btn btn-secondary"
          onClick={() => navigate('/profile')}
          style={{ width: '100%' }}
        >
          返回我的
        </button>
      </div>
    </Layout>
  );
}

export default Membership;
